<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账户名称：</span>
        </div>
        <el-input v-model="formData.wxAccountName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">微信AppId：</span>
        </div>
        <el-input v-model="formData.wxAppId" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">微信Secret：</span>
        </div>
        <el-input v-model="formData.wxSecret" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系人：</span>
        </div>
        <el-input v-model="formData.contact" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系电话：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" type="textarea" :rows="3" size="small" style="width: 280px" />
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import {api} from '../../../api/ConfigWx'
import {errorHandler} from '../../../../utils/errorHandler'
import {nSuccess} from '../../../../utils/notice'

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    TextTitle,
    Breadcrumb},
  name: 'wx-add',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'housing-management'
      }, {
        value: '配置管理',
        name: 'wx-config'
      }, {
        value: '微信账户配置'
      }],
      mainTitle: '添加微信账户',
      subheading: '添加微信的账户信息，用户缴费收款账户、消费收款账户和应用授权的配置',
      formData: {
        wxAccountName: '',
        wxAppId: '',
        wxSecret: '',
        phone: '',
        contact: '',
        memo: ''
      }
    }
  },
  methods: {
    goToAliConfig () {
      this.$router.push({
        name: 'ali-config'
      })
    },
    confirm () {
      this.$axios.post(api.addWXAccount, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.goToAliConfig()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancel () {
      this.goToAliConfig()
    }
  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: -webkit-baseline-middle;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/ConfigurationManagement/ConfigWx/WxAdd.vue